module.exports = __webpack_public_path__ + "static/media/15.d530a6a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/15.svg
// module id = 127
// module chunks = 0